export type TUnsavedWork = 'notes' | 'ticket' | 'notesAndTicket';

export const CLOSE_CONFIRM_TITLE = 'Close without saving?';

export const CLOSE_CONFIRM_KEEP = 'Keep editing';

export const CLOSE_CONFIRM_CLOSE = 'Close anyway';

export const closeConfirmBody = (work: TUnsavedWork): string => {
  switch (work) {
    case 'ticket':
      return 'The ticket you entered has not been submitted.';
    case 'notesAndTicket':
      return 'Your notes have not finished saving, and the ticket you entered has not been ' +
        'submitted.';
    case 'notes':
    default:
      return 'Your notes have not finished saving.';
  }
};

export const unsavedWork = (notes: boolean, ticket: boolean): TUnsavedWork | null => {
  if (notes && ticket) {
    return 'notesAndTicket';
  }
  if (ticket) {
    return 'ticket';
  }
  if (notes) {
    return 'notes';
  }
  return null;
};
